import { useState, useRef } from 'react'
import styled from '@emotion/styled'
import { FilterList } from '@mui/icons-material'
import { Button, Theme } from '@mui/material'
import { FIELD_ID_ALL } from '@datasets/dataset-query-context'
import { useDatasetQueryContext } from '@datasets/dataset-query-context/hooks'
import { colors } from '@global/constants'
import * as css from './styles'
import { GlobalFilterPopover } from '../../GlobalFilterPopover'
import { t } from '@lingui/core/macro'

const FilterCount = styled.span<{ theme?: Theme }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  min-width: 16px;
  margin: 4px;
  background-color: ${({ theme }) => theme.palette.primary.main};
  color: ${colors.white};
  border-radius: 50%;
  font-size: 11px;
  line-height: 16px;
`

export const FilterRows = () => {
  const { hasQueryOptions, datasetLoading } = useDatasetQueryContext()
  const [open, setOpen] = useState<boolean>(false)
  const anchorEl = useRef<HTMLButtonElement | null>(null)
  const filtersApplied = hasQueryOptions(FIELD_ID_ALL)

  return (
    <>
      <Button
        ref={anchorEl}
        size="small"
        disableRipple
        onClick={handleClick}
        disabled={datasetLoading}
        data-testid="filter-button"
      >
        <FilterList css={css.buttonIcon} data-testid="filter-list" />
        <css.ButtonLabel>{t`Filters`}</css.ButtonLabel>
        {filtersApplied && <FilterCount data-testid="filter-counter">{filtersApplied}</FilterCount>}
      </Button>
      <GlobalFilterPopover anchorEl={anchorEl.current} open={open} onClose={handleClose} />
    </>
  )

  function handleClick(): void {
    setOpen(true)
  }

  function handleClose(): void {
    setOpen(false)
  }
}
